import { NavLink } from 'react-router-dom';

import HelpIcon from '@mui/icons-material/HelpOutline';
import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function HelpButton() {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    return (
        <IconButton
            sx={{ color: isDark ? theme.palette.primary.accent : theme.palette.secondary.dark }}
            disableRipple
            component={NavLink}
            to="/help"
            data-testid="helpButton"
        >
            <HelpIcon fontSize="medium" />
        </IconButton>
    );
}
